import { IBaseProperties } from '@bvi/api-interfaces/entity/base';
import { ICompanyWithUsers } from '@bvi/api-interfaces/entity/company';
import { ISubscription } from '@bvi/api-interfaces/entity/subscription';

export enum ClientStatus {
  Unconfirmed = 'unconfirmed',
  Active = 'active',
  Archived = 'archived',
}

export enum AccountStatus {
  Inactive = 'inactive',
  Active = 'active',
}

export enum PaymentMethod {
  MonthlyAch = 'monthly_ach',
  UpfrontPrepay = 'upfront_prepay',
  WireTransfer = 'wire_transfer',
  CreditCard = 'credit_card',
  Other = 'other',
}

export interface IClientBase extends IBaseProperties {
  status: ClientStatus;
  accountStatus: AccountStatus;
  pricingNarrative?: string | null;
  accountManagerName?: string | null;
  accountManagerEmail?: string | null;
  supportLiaisonName?: string | null;
  supportLiaisonEmail?: string | null;
  paymentMethod?: PaymentMethod | null;
  paymentMethodNotes?: string | null;
  orientationAt?: Date | null;
}

export interface IClientWithSubscription extends IClientBase {
  subscription: ISubscription;
}

export interface IClient extends IClientWithSubscription {
  company: ICompanyWithUsers;
}
